import t from "min-document";
let o = {};
typeof globalThis < "u" && (o = globalThis);
typeof window < "u" && (o = window);
let e;
typeof document < "u" ? e = document : (e = o["__GLOBAL_DOCUMENT_CACHE@4"], e || (e = o["__GLOBAL_DOCUMENT_CACHE@4"] = t));
const d = e;
export {
  d as default
};
